import { Inject, Injectable, Injector }from '@angular/core';



@Injectable({ providedIn: 'root' })
export class Document360_DatasourceService {

  constructor(
    private injector: Injector
  ) {
  }

  public Document360: Document360_DatasourceService = this;

  // injecting lazily in order to avoid circular dependencies
}

